var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtentiWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62 62",
    style: {
      enableBackground: "new 0 0 62 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st12{fill:#FFD685;}\r\n\t.st13{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1190_00000137850804607465307790000015167567613151144616_",
    transform: "translate(183.328 30.834)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_45-3_00000171714085227997598860000004287695513139273865_",
    className: "st12",
    cx: -152.3,
    cy: 0.2,
    rx: 31,
    ry: 31
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9113551_user_check_solid_icon",
    className: "st13",
    d: "M30.1,17c-4.3,0-7.8,3.5-7.8,7.8c0,2.6,1.3,5,3.4,6.5 C21.7,33,19,37,19,41.4h2.2c0-4.9,4-8.9,8.9-8.9c0,0,0,0,0,0c1.5,0,2.9,0.4,4.2,1.1c-3.2,3.9-2.6,9.5,1.2,12.7 c3.9,3.2,9.5,2.6,12.7-1.2c3.2-3.9,2.6-9.5-1.2-12.7c-3.2-2.6-7.7-2.7-11-0.4c-0.5-0.3-1-0.6-1.6-0.8C38,28.8,39,24,36.6,20.4 C35.1,18.3,32.7,17,30.1,17L30.1,17z M30.1,19.2c3.1,0,5.6,2.5,5.6,5.6s-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6l0,0 C24.6,21.7,27,19.2,30.1,19.2C30.1,19.2,30.1,19.2,30.1,19.2L30.1,19.2z M41.2,32.5c3.7,0,6.7,3,6.7,6.7c0,3.7-3,6.7-6.7,6.7 c-3.7,0-6.7-3-6.7-6.7C34.6,35.5,37.5,32.5,41.2,32.5C41.2,32.5,41.2,32.5,41.2,32.5z M44.9,36.2l-3.7,3.7l-2.5-2.5l-1.6,1.6 l3.3,3.3l0.8,0.8l0.8-0.8l4.5-4.5L44.9,36.2L44.9,36.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtentiWeb);
export default __webpack_public_path__ + "static/media/UtentiWeb.063336747c749473148766bfa811286b.svg";
export { ForwardRef as ReactComponent };